// extracted by mini-css-extract-plugin
module.exports = {"areaButtons":"category_areaButtons__3Hw19"};